module.exports = __webpack_public_path__ + "static/media/play.8913c38c.svg";